const ROLE_LABELS: Record<string, string> = {
  SUPER_ADMIN: 'Super Admin',
  TENANT_ADMIN: 'Organization Admin',
  CRM_ADMIN: 'CRM Administrator',
  SALES_DIRECTOR: 'Sales Director',
  HR_MANAGER: 'HR Manager',
  HR_ADMIN: 'HR Admin',
  PAYROLL_MANAGER: 'Payroll Manager',
  SALES_MANAGER: 'Sales Manager',
  DEPARTMENT_HEAD: 'Department Head',
  PEOPLE_MANAGER: 'People Manager',
  TEAM_LEAD: 'Team Lead',
  SALES_REP: 'Sales Representative',
  MANAGER: 'Manager',
  ATTENDANCE_GOVERNANCE_APPROVER: 'Attendance Governance Approver',
  EMPLOYEE: 'Employee',
};

function normalizeRoleKey(role: string): string {
  return role
    .trim()
    .replace(/[\s-]+/g, '_')
    .toUpperCase();
}

function humanizeRole(role: string): string {
  return normalizeRoleKey(role)
    .toLowerCase()
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function getRoleDisplayName(role?: string | null): string {
  if (!role) {
    return 'Employee';
  }

  const key = normalizeRoleKey(role);
  return ROLE_LABELS[key] ?? humanizeRole(role);
}
